export class DropdownValueObject {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  label: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(value: any, label?: string | null) {
    this.value = value;
    this.label = label || String(value);
  }
}
